export default __webpack_public_path__ + "static/media/widget_watchbox_vpmnq1d_sell.c29c6734.mp3";